import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

interface Service {
  id: number;
  title: string;
  slug: string;
  category: string;
  image: string;
  summary: string;
}

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
  services: Service[] = [];
  filteredServices: Service[] = [];
  categories: string[] = [];
  selectedCategory: string = 'All';

  constructor(
    private http: HttpClient,
    private router: Router,
    private titleService: Title,
    private metaService: Meta
  ) { }

  ngOnInit(): void {
    this.loadServices();
    this.titleService.setTitle('Best Internet fax services - Secure fax service online');
    this.metaService.updateTag({ name: 'description', content: 'B2BeFax service allow you to send faxes electronically.They often provide online platforms or mobile apps for easy faxing.Send bulk faxes effortlessly, customize your lists, and ensure data security.' });
    this.metaService.updateTag({ name: 'keywords', content: 'internet fax services, secure fax service online, fax communication, confidentiality, integrity, digital faxes' });
  }

  loadServices(): void {
    this.http.get<any>('assets/data/services.json').subscribe(data => {
      this.services = data.services;
      this.filteredServices = [...this.services];
      this.categories = ['All', ...new Set(this.services.map(service => service.category))];
    });
  }

  filterByCategory(category: string): void {
    this.selectedCategory = category;
    if (category === 'All') {
      this.filteredServices = [...this.services];
    } else {
      this.filteredServices = this.services.filter(service => service.category === category);
    }
  }

  navigateToService(slug: string): void {
    this.router.navigate(['/services', slug]);
  }
}
